import * as types from './actiontypes';
import { RATE_CARD, SIGNUP_CARD } from './reducer';

export function painGuideHideEnglish() {
  return {
    type: types.PAIN_GUIDE_HIDE_ENGLISH,
  };
}

export function painGuideIgnoreEnglish() {
  return {
    type: types.PAIN_GUIDE_IGNORE_ENGLISH,
  };
}
export function painGuideIntroduced() {
  return {
    type: types.PAIN_GUIDE_INTRODUCED,
  };
}
export function hideCard(cardType) {
  return {
    type: types.CARD_HIDE,
    payload: cardType,
  };
}

export function setAppRated() {
  return {
    type: types.RATE_ME_RATED,
    payload: RATE_CARD,
  };
}

export function setSignUpHidden() {
  return {
    type: types.CARD_HIDE,
    payload: SIGNUP_CARD,
  };
}

export function delayAppRate() {
  return {
    type: types.RATE_ME_DELAY,
    payload: {
      id: -1,
    },
  };
}

export function delayQuestionnaires(timeNext) {
  return {
    type: types.QUESTIONNAIRES_DELAY,
    payload: timeNext,
  };
}

export function toggleCardCollapse(cardType) {
  return {
    type: types.FEED_CARD_TOGGLE_CARD_COLLAPSE,
    payload: cardType,
  };
}

export function closeCard(card) {}

export function reOrderCards(cards) {
  return {
    type: types.FEED_CARD_RE_ORDER_CARDS,
    payload: cards,
  };
}
